module.exports = __webpack_public_path__ + "img/x-square.2869249c.svg";